import { z } from 'zod'
import { dateValueSchema } from './date-value'

/**
 * 建立資料 共同欄位 - Schema
 */
export const commonCreateDataSchema = z.object({
  /** 建立日期 */
  createTime: dateValueSchema.optional(),
  /** 建立人員 */
  createBy: z.string().optional(),
  /** 建立場站 */
  createStation: z.string().optional()
})

/**
 * 建立資料 共同欄位 - Schema
 */
export interface CommonCreateData
  extends z.infer<typeof commonCreateDataSchema> {}
